import dayjs from "dayjs";
import React, { useState } from "react";
import Button from "../../../../../components/ui/Button/Button";
import { Dropdown } from "../../../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../../../components/ui/InputDate/InputDate";
import InputSearch from "../../../../../components/ui/InputSearch/InputSearch";

const checkByOptions = [
  { id: "productName", name: "상품명" },
  { id: "orderNo", name: "주문번호" },
  { id: "orderer", name: "주문자(담당자)" },
];

const orderTypeOptions = [
  { id: "", name: "전체", inputId: "order-type-all" },
  {
    id: "AUTOMATIC_INVENTORY",
    name: "자동(재고)",
    inputId: "order-type-automatic",
  },
  {
    id: "MANUAL_INVENTORY",
    name: "수동(재고)",
    inputId: "order-type-manual",
  },
  {
    id: "MANUAL_ONE_DAY_MALL",
    name: "수동(원데이몰)",
    inputId: "order-type-oneday",
  },
];

const statusOptions = [
  { id: "", name: "전체", inputId: "order-status-all" },
  { id: "IN_PROGRESS", name: "진행중", inputId: "order-status-in-progress" },
  { id: "COMPLETED", name: "완료", inputId: "order-status-completed" },
];

function Filter(props) {
  const { onSubmitFilter, onResetFilter, isOrderManagement } = props;

  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedDateOption, setSelectedDateOption] = useState();
  const [checkBy, setCheckBy] = useState("productName");
  const [keyword, setKeyword] = useState("");

  const buildFilterParams = () => {
    const params = {};

    if (type) {
      params.type = type;
    }
    if (status) {
      params.status = status;
    }
    if (fromDate) {
      params.from = fromDate.startOf("day").valueOf();
    }
    if (toDate) {
      params.to = toDate.endOf("day").valueOf();
    }
    if (keyword?.trim() && checkBy) {
      params[checkBy] = keyword.trim();
    }

    return params;
  };

  const handleSubmit = () => {
    onSubmitFilter?.(buildFilterParams());
  };

  const handleReset = () => {
    setType("");
    setStatus("");
    setFromDate(null);
    setToDate(null);
    setSelectedDateOption(undefined);
    setCheckBy("productName");
    setKeyword("");
    onResetFilter?.();
  };

  const onChangeFromDate = (value) => {
    setFromDate(value);
    setSelectedDateOption(undefined);
  };

  const onChangeToDate = (value) => {
    setToDate(value);
    setSelectedDateOption(undefined);
  };

  const onChangeDatePreset = (increment) => {
    const end = dayjs().endOf("day");
    let start = dayjs().startOf("day");

    if (increment === 7) {
      start = dayjs().subtract(7, "day").startOf("day");
    } else if (increment === 30) {
      start = dayjs().subtract(1, "month").startOf("day");
    } else if (increment === 90) {
      start = dayjs().subtract(3, "month").startOf("day");
    }

    setFromDate(start);
    setToDate(end);
    setSelectedDateOption(increment);
  };

  return (
    <div className="mb-8 mt-4 bg-[#f2f2f4]">
      <div
        className={`${
          isOrderManagement && "justify-between"
        } flex items-center px-5 pt-3`}
      >
        <div className="flex items-center">
          <span className="w-24 font-bold">주문구분</span>
          <div className="flex gap-8">
            {orderTypeOptions.map((option) => (
              <div key={option.id || "all"} className="flex gap-1 items-center">
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id={option.inputId}
                  value={option.id}
                  name="orderType"
                  checked={type === option.id}
                  onChange={(event) => setType(event.target.value)}
                />
                <label htmlFor={option.inputId}>{option.name}</label>
              </div>
            ))}
          </div>
        </div>
        {isOrderManagement && (
          <div>
            <Button
              borderColor="border border-secondary-grey"
              paddingButton="py-1"
              text={`필터 검색`}
              onClick={handleSubmit}
            />
            <Button
              borderColor="border border-secondary-grey"
              paddingButton="py-1"
              text={`필터 초기화`}
              onClick={handleReset}
            />
          </div>
        )}
      </div>
      <div className="flex items-center px-5 pt-1.5">
        <div className="flex items-center">
          <span className="w-24 font-bold">상태</span>
          <div className="flex gap-8">
            {statusOptions.map((option) => (
              <div key={option.id || "all"} className="flex gap-1 items-center">
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id={option.inputId}
                  value={option.id}
                  name="orderStatus"
                  checked={status === option.id}
                  onChange={(event) => setStatus(event.target.value)}
                />
                <label htmlFor={option.inputId}>{option.name}</label>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex items-center px-5 pt-2">
        <div className="flex items-center w-full">
          <span className="w-24 font-bold">기간</span>
          <div className="flex gap-2 text-secondary-grey items-center">
            <InputDate
              value={fromDate}
              onChange={onChangeFromDate}
            />
            {" - "}
            <InputDate
              value={toDate}
              onChange={onChangeToDate}
            />
            <div
              className={`border h-8 bg-white text-center rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
            >
              <div
                onClick={() => onChangeDatePreset(1)}
                className={`${
                  selectedDateOption === 1
                    ? "bg-primary-blue rounded-l-[4px] text-white"
                    : ""
                } py-1 w-[42px] m-auto cursor-pointer text-[10px]`}
              >
                오늘
              </div>
              <div
                onClick={() => onChangeDatePreset(7)}
                className={`${
                  selectedDateOption === 7 ? "bg-primary-blue text-white" : ""
                } py-1 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                7일
              </div>
              <div
                onClick={() => onChangeDatePreset(30)}
                className={`${
                  selectedDateOption === 30 ? "bg-primary-blue text-white" : ""
                } py-1 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                1개월
              </div>
              <div
                onClick={() => onChangeDatePreset(90)}
                className={`${
                  selectedDateOption === 90
                    ? "bg-primary-blue rounded-r-[4px] text-white"
                    : ""
                } py-1 w-[42px] m-auto cursor-pointer text-[10px] `}
              >
                3개월
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center px-5 py-3">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center">
            <span className="w-24 font-bold">검색어</span>
            <div className="flex gap-4">
              <Dropdown
                backgroundDropdown="bg-white"
                width="w-28"
                placeholder="상품명"
                textColor="text-black"
                positionDropdown="top-10"
                options={checkByOptions}
                defaultValue={checkBy}
                onClickItem={(id) => setCheckBy(id)}
              />
              <InputSearch
                isMagnifyingGlass={false}
                onChange={(value) => setKeyword(value)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Filter;
